export default __webpack_public_path__ + "static/media/safety.1737bd43.png";